<template>
    <div>
        <app-page-header></app-page-header>
        <v-container grid-list-xl>
            <!-- chart -->
             <v-layout row wrap justify-center fill-height>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <MaintenanceScheduleEntrances></MaintenanceScheduleEntrances>
                </v-flex>
            </v-layout>

            <!-- kriterij iskanja -->
            <v-layout row wrap align-center justify-center fill-height>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-card>
                            <v-card-title>
                                    <span class="subtitle-1"><v-icon left>mdi-filter</v-icon> Filter results</span>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click="card1 = !card1">
                                        <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                    </v-btn>
                            </v-card-title>
                            <v-divider v-show="card1"></v-divider>
                            <v-card-text v-show="card1">
                            <!-- datumska omejitev -->
                             <!--
                                <v-container grid-list-xl text-x-center align-center class="container--filters">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs8 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Date limit (from - to)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md4 align-content-center>
                                            <v-menu
                                                ref="start_date_menu"
                                                :close-on-content-click="false"
                                                v-model="start_date_menu"
                                                :nudge-right="40"
                                                :return-value.sync="restriction_start_date"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="restriction_start_date_formatted"
                                                        label="Date from"
                                                        prepend-icon="mdi-calendar-today"
                                                        readonly
                                                        clearable
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="startDateMenuSave(restriction_start_date)" v-model="restriction_start_date" no-title scrollable locale="en-us">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 md4 align-content-center>
                                            <v-menu
                                                ref="end_date_menu"
                                                :close-on-content-click="false"
                                                v-model="end_date_menu"
                                                :nudge-right="40"
                                                :return-value.sync="restriction_end_date"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="restriction_end_date_formatted"
                                                        label="Date to"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        clearable
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="endDateMenuSave(restriction_end_date)" v-model="restriction_end_date" no-title scrollable locale="en-us">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                -->
                                <!-- sales locations -->
                                <v-container grid-list-xl text-x-center align-center class="container--filters">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Sales locations</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                            v-model="selected_locations"
                                            :items="locations"
                                            label="Select locations"
                                            multiple
                                            chips
                                            clearable
                                            deletable-chips
                                            prepend-icon="mdi-monitor-star"
                                            item-value="cashiers"
                                            item-text="name"
                                            return-object
                                            dense
                                            no-data-text="No data to display"
                                        ></v-select>   
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- cashiers -->
                                <v-container grid-list-xl text-x-center align-center class="container--filters">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Cashiers</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                            v-model="selected_cashiers"
                                            :items="cashiers"
                                            label="Select cashiers"
                                            multiple
                                            chips
                                            clearable
                                            deletable-chips
                                            prepend-icon="mdi-monitor-star"
                                            item-value="id"
                                            item-text="name"
                                            return-object
                                            dense
                                            no-data-text="No data to display"
                                        ></v-select>   
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- schedule status -->
                                 <v-container grid-list-xl text-x-center align-center class="container--filters">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Schedule status (All / Closed)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-switch
                                            v-model="switch_expired"
                                            :label="`Status: ${(switch_expired) ? 'Closed' : 'All'}`"
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- service done -->
                                 <!--
                                 <v-container grid-list-xl text-x-center align-center class="container--filters">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Service Completed (All / Completed)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-switch
                                            v-model="switch_service_completed"
                                            :label="`Completed: ${(switch_service_completed) ? 'Sevice Done' : 'All'}`"
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                -->

                                <!-- service done (btn toggle) -->
                                 <v-container grid-list-xl text-x-center align-center class="container--filters">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Service Completed (All / Serviced / Pending)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-btn-toggle
                                                v-model="btn_toggle_service_completed"
                                                mandatory
                                            >   
                                            <!--
                                                <v-btn
                                                    value="all"
                                                    small
                                                >
                                                    All
                                                </v-btn>
                                            -->
                                                <v-btn
                                                value="all"
                                                small
                                                :class="{ 'info white--text': btn_toggle_service_completed === 'all' }"
                                            >
                                                <v-icon
                                                    v-if="btn_toggle_service_completed === 'all'"
                                                    left
                                                    small
                                                    class="white--text"
                                                >
                                                    mdi-format-list-bulleted
                                                </v-icon>

                                                All
                                            </v-btn>

                                                <v-btn
                                                    value="completed"
                                                    small
                                                    :class="{ 'success white--text': btn_toggle_service_completed === 'completed' }"
                                                >
                                                    <v-icon
                                                        v-if="btn_toggle_service_completed === 'completed'"
                                                        left
                                                        small 
                                                        color="white"
                                                    >
                                                        mdi-check
                                                    </v-icon>

                                                    Serviced
                                                </v-btn>

                                                <v-btn
                                                    value="pending"
                                                    small
                                                    :class="{ 'error white--text': btn_toggle_service_completed === 'pending' }"
                                                >
                                                    <v-icon
                                                        v-if="btn_toggle_service_completed === 'pending'"
                                                        left
                                                        small
                                                        color="white"
                                                    >
                                                        mdi-close
                                                    </v-icon>

                                                    Pending
                                                </v-btn>
                                            </v-btn-toggle>

                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-divider v-show="card1"></v-divider>
                            <span v-if="card1">
                                <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                                <v-btn   @click="search()" color="secondary" dark  block style=""><v-icon left>mdi-magnify</v-icon>Search</v-btn>
                                <!--<br>-->
                                <v-btn disabled   @click="exportData()" color="#5E35B1" dark  block style=""><v-icon left>mdi-export</v-icon>Export&nbsp;</v-btn>
                                </v-card-text>
                                <v-card-text v-else>
                                    <v-btn  @click="search()" color="secondary" dark small style="margin-right:10px;"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
                                    <v-btn disabled  @click="exportData()" color="#5E35B1" dark small><v-icon left>mdi-export</v-icon>Export&nbsp;</v-btn>
                                </v-card-text>
                            </span>
                        </v-card>
                </v-flex>
            </v-layout>

            <div style="min-height:10px"></div>
            
            <maintenance-schedule-group-data-table
            :settings="dataTableMaintenanceScheduleGroupSettings"
            :queryParameters="queryParameters"
            ></maintenance-schedule-group-data-table> 

            <data-table-toggle-columns
            :dataTableId="dataTableMaintenanceScheduleGroupSettings.id"
            :columns="dataTableMaintenanceScheduleGroupSettings.headers"
            dataTableColumnsMenuId="toggle-maintenance-schedule-group-list-columns"

            ></data-table-toggle-columns>

        </v-container>
    </div>
</template>

<script>
import { EventBus } from '@/main.js'
import { getCurrentDate, getCurrentTime, formatDate, getAppSettingsFromLocalStorage } from '@/helpers/utilities'
import { isMobileDevice } from '@/helpers/utilities.js'
import { addExportToQueue } from '@/helpers/services.js'
const DataTableToggleColumns = () => import('@/components/DataTableToggleColumns.vue')
const MaintenanceScheduleEntrances = () => import('@/components/MaintenanceScheduleEntrances.vue')
const MaintenanceScheduleGroupDataTable = () => import('@/components/MaintenanceScheduleGroupDataTable.vue')

export default {
    components: {
        DataTableToggleColumns,
        MaintenanceScheduleEntrances,
        MaintenanceScheduleGroupDataTable
    },

    data: () => ({
        card1: true,
        card2: true,
        card3: true,

        interval1: null,

        cashiers: [],
        locations: [],

        selected_cashiers: [],
        selected_locations: [],

        restriction_start_date: null,
        restriction_end_date:null,
        restriction_start_date_formatted: null,
        restriction_end_date_formatted: null,
        start_date_menu: false,
        end_date_menu:false,
        switch_expired: true,
        switch_service_completed: false,
        //btn_toggle_service_completed: 'all',
        btn_toggle_service_completed: 'pending',


        // servisni intervali
        dataTableMaintenanceScheduleGroupSettings: {
            id: 'dtMaintenanceScheduleGroup',
            title: 'Maintenances',
            sortColumn: ['id'],
            sortDirection: ['desc'],
            progressHeight: 3,
            headers: [
                { text: "ID", value: "id", class: "text-xs-left", visibility: true },
                { text: "Sales location", value: "business_premise.name", class: "text-xs-left", visibility: true, sortable: true },
                { text: "Cashier - entrances (1)", value: "schedule_1.cashier_entrances", class: "text-xs-left", visibility: true, sortable: false },
                { text: "Cashier - entrances (2)", value: "schedule_2.cashier_entrances", class: "text-xs-left", visibility: true, sortable: false },
                //{ text: "Service timestamp", value: "service_completed_at_formatted", class: "text-xs-left", visibility: true, sortable: false },
                //{ text: "Servicemen", value: "servicemen.name", class: "text-xs-left", visibility: true, sortable: false },
                { text: "Service done", value: "service_completed", class: "text-xs-left", visibility: true, sortable: true },
                { text: "Schedule start", value: "created_at_formatted", class: "text-xs-left", visibility: true, sortable: true },
                { text: "Schedule end", value: "completed_at_formatted", class: "text-xs-left", visibility: true, sortable: true },
                { text: "Schedule status", value: "schedule_status", class: "text-xs-left", visibility: true, sortable: true },
                { text: "Service timestamp", value: "service_completed_at_formatted", class: "text-xs-left", visibility: true, sortable: false },
                { text: "Servicemen", value: "servicemen.name", class: "text-xs-left", visibility: true, sortable: false },
                { text: "Actions", value: "action", align: "right", class: "text-xs-right", sortable: false, visibility: true}
            ],
            updateInterval: true,
            rowsPerPage: 10,
            endpoint: 'petrol/maintenance-schedules',
            editItem: {
                route: null,
                routeParameterValue: null
            },
            deleteItem: {
                vuexAction: 'DELETE_MAINTENANCE',
                replaceStrWithColumnValue: 'id',
                routeParameterValue: 'uuid',
                confirmationText : "Are you sure you want to delete maintenance number #{str_to_replace} ?",
                dialogConfirmSuccessText: 'Maintenance {str_to_replace} deleted.',
                dialogConfirmFailText: 'An error occurred while deleting the maintenance {str_to_replace}. Try again.'
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: false,
                    addNewRoute: '',
                    toggleColumns: true
                }
            },

            eventBus: {
                refreshDataTable: 'refresh_dt_maintenance_schedule_group',
                totalItems : {
                    event: ''
                },
                search: 'dt-maintenance-schedule-group-search',
                toggleColumnsId: 'toggle-maintenance-schedule-group-list-columns'
            }


        }
        
    }),
    
    watch: {
        selected_locations(value) {
            //window.console.log(value)
            //this.search()
        },

        selected_cashiers(value) {
            //window.console.log(value)
            //this.search();

        },

        switch_expired(value) {
            //window.console.log("switch_expired: ", value)
            this.search()
        },

        switch_service_completed(value) {
            //window.console.log("switch_service_done: ", value)
        },

        btn_toggle_service_completed(value) {
            //window.console.log("btn_toggle_service_completed: ", value)
            this.search();
        },

        card1: {
            handler(value) {
                //window.console.log("Telemetry card1: " + value)
                this.$store.commit("APP_SETTING", {
                    setting: "maintenances",
                    key: "filter_results_open",
                    value: value
                })
            },

            //immediate: true
        },

        restriction_start_date (val) {
            //window.console.log(val)
            if(isNaN(Date.parse(val)) == false) {
                this.restriction_start_year = new Date(val).getFullYear()
            }

            this.restriction_start_date_formatted = formatDate(val)

            /*
            if(val) {
                this.$store.commit("APP_SETTING", {
                    setting: "invoices",
                    key: "restriction_start_date",
                    value: val
                })
            }
            */
        },

        restriction_end_date (val) {
            if(isNaN(Date.parse(val)) == false) {
                this.restriction_end_year = new Date(val).getFullYear()
            }

            this.restriction_end_date_formatted = formatDate(val)
            /*
            if(val) {
                this.$store.commit("APP_SETTING", {
                    setting: "invoices",
                    key: "restriction_end_date",
                    value: val
                })
            }
            */
        },
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        queryParameters() {

            let parameters = {
                selectedCashiers: this.selected_cashiers.map(item => item.uuid),
                selectedLocations: this.selected_locations.map(item => item.id),
                scheduleStatusExpired: this.switch_expired,
                //serviceCompleted: this.switch_service_completed
                serviceCompleted: this.btn_toggle_service_completed
            }

            
            let selectedLocationCashiers = [];
            if(this.selected_locations.length > 0) {
                this.selected_locations.forEach(selectedLocation => {
                    selectedLocation.cashiers.forEach(cashier => {
                        selectedLocationCashiers.push(cashier.uuid)
                    })
                })
            }

            parameters.selectedLocationCashiers = selectedLocationCashiers;
            
            return parameters;
        },
    },

    methods: {
        search() {
            let vm = this
            setTimeout(() => {
                EventBus.$emit(this.dataTableMaintenanceScheduleGroupSettings.eventBus.refreshDataTable, vm.queryParameters);
                EventBus.$emit('maintenance-schedule-entrances', vm.queryParameters);
            }, 250)
        },

        exportData() {
            window.console.log("exporting data ...");
            let parameters = {
                selectedCashiers: this.selected_cashiers.map(item => item.uuid)
            }

            let selectedLocationCashiers = [];
            if(this.selected_locations.length > 0) {
                this.selected_locations.forEach(selectedLocation => {
                    selectedLocation.cashiers.forEach(cashier => {
                        selectedLocationCashiers.push(cashier.uuid)
                    })
                })
            }

            parameters.selectedLocationCashiers = selectedLocationCashiers;
            
            //addExportToQueue('maintenances', parameters);
        },

        displayResults() {
            let vm = this
            setTimeout(() => {
                EventBus.$emit(this.dataTableMaintenanceScheduleGroupSettings.eventBus.refreshDataTable, vm.queryParameters);
                EventBus.$emit('maintenance-schedule-entrances', vm.queryParameters);
            }, 280)
        },

        setParametersData() {
            var vm = this
            vm.$store.commit('SET_PROGRESS', true)
            vm.$store.dispatch('PARAMETERS_DATA')
            .then(response => {
                //console.log(response)
                //console.log(response.data)
                this.locations = response.data.businessPremises
                this.cashiers = response.data.cashiers

                //vm.displayResults();
            })
            .catch(error => {
                console.error("### setParametersData ###");
                console.log(error)
            })
            .finally(() => {
                setTimeout(() => {
                    vm.$store.commit('SET_PROGRESS', false)  
                }, 700)
            })
        },

        startDateMenuSave(value) {
            this.$refs.start_date_menu.save(value)
            this.start_date_menu = false
        },

        endDateMenuSave(value) {
            this.$refs.end_date_menu.save(value)
            this.end_date_menu = false
        },
    },

    created() {
        var vm = this
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 

        vm.card1 = vm.$store.getters.appSettings.maintenances.filter_results_open

        /*if(isMobileDevice(this)) {
            this.card1 = false
        }*/

        this.setParametersData();

        this.interval1 = setInterval(() => {
            vm.setParametersData()
        }, process.env.VUE_APP_DATA_TABLES_REFRESH_INTERVAL || 180000)

        let ipp3 = getAppSettingsFromLocalStorage({
            setting: "dt_maintenance_schedule_groups",
            key: "items_per_page"
        })

        if(ipp3 !== null) {
            this.dataTableMaintenanceScheduleGroupSettings.rowsPerPage = ipp3
        }
    },

    mounted() {

    },

    beforeDestroy() {

        EventBus.$off(this.dataTableMaintenanceScheduleGroupSettings.id)
        EventBus.$off(this.dataTableMaintenanceScheduleGroupSettings.eventBus.refreshDataTable)
        EventBus.$off(this.dataTableMaintenanceScheduleGroupSettings.eventBus.search)

        this.$store.commit('SET_SEARCH', '');
        this.$store.commit('SET_SEARCH_FIELD_STATE', false);
        this.$store.commit('SET_MOBILE_SEARCH', false)
    }
}

</script>

<style scoped>

</style>